/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_No_TrackingInputs */



/**
* | output |
* | --- |
* | "No tracking cookies. We count visits without storing anything on your device." |
*
* @param {Footer_No_TrackingInputs} inputs
* @param {{ locale?: "nb-NO" | "en-GB" | "sv-SE" }} options
* @returns {LocalizedString}
*/
export const footer_no_tracking = /** @type {((inputs?: Footer_No_TrackingInputs, options?: { locale?: "nb-NO" | "en-GB" | "sv-SE" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_No_TrackingInputs, { locale?: "nb-NO" | "en-GB" | "sv-SE" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en-GB") return /** @type {LocalizedString} */ ("No tracking cookies. We count visits without storing anything on your device.")
	if (locale === "sv-SE") return /** @type {LocalizedString} */ ("Inga spårningskakor. Vi räknar besök utan att lagra något på din enhet.")
	return /** @type {LocalizedString} */ ("Ingen sporingscookies. Vi teller besøk uten å lagre noe på enheten din.")
});